export const getDocNode = () => ({
  content: 'block+'
});